import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { getInsuranceCoverageRequirementStatus } from "./getInsuranceCoverageRequirementStatus";
import { RequirementContextType } from "../../../../types";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

export const getInsuranceCoveragePayerRequirementStatus = (
  requirement: IRequirementResponse,
  insuranceCoverage: InsuranceCoverageMonitor | undefined
) => {
  // For payee view, use the same logic as general status
  return getInsuranceCoverageRequirementStatus(
    requirement,
    insuranceCoverage,
    RequirementContextType.Payer
  );
};
